import { lazy } from 'react';

const CustomPlanificationsTracingAggregate = lazy(() => import('./CustomPlanificationsTracingAggregate'));

export default CustomPlanificationsTracingAggregate;
